// Global Instructions Rule Applied!
export const SET_TRANCHES = 'tranches/SET_TRANCHES'
export const APPEND_TRANCHES = 'tranches/APPEND_TRANCHES'
export const SET_TRANCHES_ACTIVE_FILTERS = 'tranches/SET_ACTIVE_FILTERS'
export const SET_TRANCHES_ACTIVE_SORTING = 'tranches/SET_ACTIVE_SORTING'
